import React, { useState, useEffect } from "react"

import {
  Card,
  CardBody,
  Col,
  Container,
  Form,
  Label,
  NavItem,
  NavLink,
  Row,
  TabContent,
  TabPane
} from "reactstrap"

import classnames from "classnames"
import { Link } from "react-router-dom"

import { CircularProgress } from "@material-ui/core";
import ReactQuill from "react-quill";
import {FaCloudUploadAlt} from "react-icons/fa";



//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb"
import Select from "react-select"
import Dropzone from "react-dropzone"
import SweetAlert from "react-bootstrap-sweetalert"

// MomentJS
import moment from 'moment'

import { frxAppOptions, happeningTypeOptions, mallOptions } from "../../common/constants"

const AddCarouselBannerNew = (props) => {

  const statusOptions = [
    { value: "Y", label: "Enable" },
    { value: "N", label: "Disable" }
  ]

  const [token, setToken] = useState()
  const [FRXAPP, setFrxApp] = useState(false)
  const [selectedFiles, setselectedFiles] = useState([])
  const [selectedSection, setselectedSection] = useState()
  const [selectedSectionFRX, setselectedSectionFRX] = useState()
  const [selectedFRXSection, setselectedFRXSection] = useState(frxAppOptions[frxAppOptions.length-1])
  const [selectedPosition, setselectedPosition] = useState(1)
  const [pocunoUrl,setPocunoUrl]= useState()
  const [selectedStatus, setselectedStatus] = useState(statusOptions[0])
  const [neverEnding, setNeverEnding] = useState(false)
  const [success_msg, setsuccess_msg] = useState(false)
  const [errorMessage, SetErrorMessage] = useState('')
  const [errorMsgAlert, setErrorMsgAlert] = useState(false)
  const [activeTab, setactiveTab] = useState(1)
  const [pocuno, setPocuno] = useState(false)
  const [unique,setUnique]=useState(false)
  const [bannersData, setBannersData] = useState([])
  const [isUniqueExist,setIsUniqueExist]=useState(false)
  const [EmptyPosition,setEmptyPosition]=useState(false)
  const [EmptyUrl,setEmptyUrl]=useState(false)
  const [externalUrl,setExternalUrl]=useState()
  const [externaLinkName,setExternalLinkName]=useState("")
  const [loader,setLoader]=useState(false)
  const [customCheck,setcustomCheck]=useState(false)
  const [customNavigation,setCustomNavigation]=useState()
  const [externalUrlErrorMessage,setExternalUrlErrorMessage]=useState('')
  const [selectedMall, setSelectedMall] = useState(null);
  const [selectedHappeningType, setSelectedHappeningType] = useState(null);

  function toggleTab(tab) {

    if (activeTab !== tab) {
      if (tab >= 1 && tab <= 4) {
        setactiveTab(tab)
      }
    }
  }
  console.log("Props:  ", props)
  useEffect(() => {

    const token = localStorage.getItem("AuthenticationToken")
    setToken(token)

    if (props?.location?.state?.frxHome) {
      setselectedSection({ value: "home", label: "Home", path: "frx-home", medium: "AppCarousel" })
      setCustomNavigation(JSON.stringify({"section":"","custom":true,"params":{"CampaignMedium":"AppCarousel","link":""}}))
    } else if (props?.location?.state?.estore) {
      setCustomNavigation(JSON.stringify({"section":"","custom":true}))
      setselectedSection({ value: "estore", label: "EStore", path: "estore", medium: "eStoreCarousel" })
    } else if (props?.location?.state?.rewards) {
      setCustomNavigation(JSON.stringify({"section":"","custom":true}))
      setselectedSection({ value: "rewards", label: "Rewards", path: "rewards", medium: "RewardsCarousel"})
      setCustomNavigation(JSON.stringify({"section":"","custom":true,"params":{"CampaignMedium":"RewardsCarousel","link":""}}))
    } else if (props?.location?.state?.makan_master) {
      setselectedSection({ value: "makan_master", label: "Makan Master", path: "makan-master", medium: "MakanMasterCarousel" })
    }
    getCarouselBanners(token)
  }, [success_msg])


  const getCarouselBanners = (token) => {
     var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + token);
    myHeaders.append("Cookie", "__cfduid=d5b74235daa6f013fde0aba762ec288811620640208");

    var requestOptions = {
      method: 'GET',
      headers: myHeaders,
      redirect: 'follow'
    };

    fetch(`${process.env.REACT_APP_TOKRI_API_URL}/api/frhub?path=carousel&env=production`, requestOptions)
      .then(response => response.json())
      .then(result => {
        let tempData = []
        let page=undefined
        if (props?.location?.state?.frxHome) {
          page="home"
        } else if (props?.location?.state?.rewards) {
          page ="rewards"
        } else if (props?.location?.state?.makan_master) {
         page ="makan_master"
        }
        if (result) {
          result?.banners?.map((item) => {
            if (item.page == page) {
              tempData = [...tempData, item]
            }
          })
          setBannersData(tempData)
        }
      })
      .catch(error => console.log('error', error));
  }

  const renderSuccessAlert = () => {
    return (
      <SweetAlert
        title="Success!"
        success
        confirmBtnBsStyle="success"
        beforeUnmount={()=>{
        props?.history.push(`/carousel-banners/${selectedSection?.path}`)
        }}
        onConfirm={() => {
          props?.history.push(`/carousel-banners/${selectedSection?.path}`)
          setsuccess_msg(false)
          setLoader(false)
        }}
        onCancel={() => {
          setsuccess_msg(false)
        }}
      >
        {"Carousel Banner Added."}
      </SweetAlert>
    )
  }

  const renderFailureAlert = () => {
    return (
      <SweetAlert
        title="Warning!"
        warning
        confirmBtnBsStyle="warning"
        onConfirm={() => {
          setErrorMsgAlert(false)
          setLoader(false)
        }}
      >
        {errorMessage ? errorMessage : "Error. Something went wrong."}
      </SweetAlert>
    )
  }


  async function handleSubmit() {
    if(isUniqueExist){
      toggleTab(1)
      return
    }
    else if(selectedSection?.value=='home' || selectedSection?.value=='rewards'){
    if(pocuno){
      if(!pocunoUrl) {
        SetErrorMessage("Please Enter Url")
        setErrorMsgAlert(true)
        toggleTab(1)
        return
      }
    }
    }
    const section = selectedSection ? selectedSection.value : ""
    const link = document.getElementById("campaign_link_input")?.value ?document.getElementById("campaign_link_input")?.value :""
    const title = document.getElementById("title_input")?.value ? document.getElementById("title_input")?.value :""
    const description = document.getElementById("description_input")?.value ? document.getElementById("description_input")?.value :""
    const article_id = document.getElementById("article_id")?.value
    const titleFRX = document.getElementById("title_input_frx")?.value;
    const position = document.getElementById("position_input").value
    let publishAt = moment(document.getElementById("publishAt_input").value)?.format("YYYY/MM/DD HH:mm");
    let unpublishAt = moment(document.getElementById("unpublishAt_input").value)?.format("YYYY/MM/DD HH:mm");
    const status = selectedStatus ? selectedStatus.value : ""
    let currentDate = moment(new Date()).format("YYYY/MM/DD HH:mm")
    currentDate = currentDate.toString()


    if(!pocuno){
      if(!selectedPosition){
        SetErrorMessage("Please Enter Position")
        setErrorMsgAlert(true)
        toggleTab(1)
        return
      }
     else if(!title){
        SetErrorMessage("Please Enter Title")
        setErrorMsgAlert(true)
        toggleTab(1)
        return
      }else if(!description){
        SetErrorMessage("Please Enter Description")
        setErrorMsgAlert(true)
        toggleTab(1)
        return
      } 
      else if (!pocuno && selectedFiles.length < 1) {
        SetErrorMessage("Please select image")
        setErrorMsgAlert(true)
        toggleTab(1)
        return
      }  
    }

   if (publishAt == "Invalid date") {
    SetErrorMessage("Please select publish date")
    setErrorMsgAlert(true)
    toggleTab(1)
    return
  } else if (!neverEnding) {
    if(unpublishAt == "Invalid date"){
    SetErrorMessage("Please select unpublish date")
    setErrorMsgAlert(true)
    toggleTab(1)
    return
       }
    else if(unpublishAt < publishAt){
    SetErrorMessage("Unpublish date should be after the publish date")
    setErrorMsgAlert(true)
    toggleTab(1)
    return
    }
  }
  else if(customCheck){
      if(!customNavigation){
        SetErrorMessage("Please Enter Navigation")
        setErrorMsgAlert(true)
        return
      }
  }


  if(selectedFRXSection.value == "NA"){
    if(!externalUrl){
      SetErrorMessage("Please Enter URL")
      setErrorMsgAlert(true)
      return
    }else if(externalUrlErrorMessage){
      SetErrorMessage("Please enter valid URL")
      setErrorMsgAlert(true)
      return
    }else if(!checkTextInsideHtml(externaLinkName)){
      SetErrorMessage("Please Enter Exit Message Description")
      setErrorMsgAlert(true)
      return
    }
  }

  if(selectedFRXSection?.label != "No Navigation" && selectedFRXSection?.label != "External Link" && !customCheck){
    if(!link){
      SetErrorMessage("Please Enter campaign tracking name")
      setErrorMsgAlert(true)
      return
    }
  }

    setLoader(true)
    let _deeplinkObjFRX = {
      section: '',
      params: {
      },
    }
 
    if(unique){
      _deeplinkObjFRX.params.is_unique=true
    }else{
      _deeplinkObjFRX.params.is_unique=false
    }

    if (FRXAPP) {
      if(pocuno){
        _deeplinkObjFRX.params.pocuno_ads=true
        if(selectedSection?.value=='home' || selectedSection?.value=='rewards'){
          _deeplinkObjFRX.params.pocuno_url= pocunoUrl
        }        
        _deeplinkObjFRX.section ="NA"
        _deeplinkObjFRX.params.CampaignMedium ="NA"
        _deeplinkObjFRX.params.link ="NA"
      }else{
         console.log("Selected section:  ", selectedFRXSection)
      if (selectedFRXSection) {
        _deeplinkObjFRX.section = selectedFRXSection.value
        _deeplinkObjFRX.params.CampaignMedium = selectedSection.medium
        _deeplinkObjFRX.params.link = link

       if (selectedFRXSection.value == "ewallet") {
          _deeplinkObjFRX.params.CampaignMedium = selectedSection.medium
          _deeplinkObjFRX.params.link = link
        }else if (selectedFRXSection.value == "NA") {
          _deeplinkObjFRX={}
          _deeplinkObjFRX.section = "NA";
          _deeplinkObjFRX.url=externalUrl;
          _deeplinkObjFRX.external_link_name=externaLinkName;
        }else if (selectedFRXSection.value == "UobUni") {
          _deeplinkObjFRX.section = "UobUni";
        }else if (selectedFRXSection.value == "ShowQR") {
          _deeplinkObjFRX.section = "ShowQR";
        }else if (selectedFRXSection.value == "digital_gift_card") {
          _deeplinkObjFRX.section = "digital_gift_card";
          _deeplinkObjFRX.params._params = "digital_gift_card_listing";
        }else if(selectedFRXSection?.value == "FRxMemberSpending"){
          _deeplinkObjFRX.login_required = true
        }
        else if (selectedFRXSection.value == "add_gift_card") {
          _deeplinkObjFRX.section = "digital_gift_card";
          _deeplinkObjFRX.params.show_add_selection_modal = true;
        }else if (selectedFRXSection.value == "buy_gift_card") {
          _deeplinkObjFRX.section = "digital_gift_card";
          _deeplinkObjFRX.params.show_buy_selection_modal = true;
        }
        else if (selectedFRXSection.value == "ArticleDetail") {
          _deeplinkObjFRX.params.data = `${selectedMall?.label}|${selectedHappeningType?.value}|${article_id}`
          _deeplinkObjFRX.params.title = titleFRX
          _deeplinkObjFRX.params.article = { category: titleFRX, id: `${selectedMall?.label}|${selectedHappeningType?.value}|${article_id}`}
        }
        else if (selectedFRXSection.value == "RewardsTab") {
          _deeplinkObjFRX.params.link = link
        }else if(selectedFRXSection?.label=="No Navigation"){
          _deeplinkObjFRX.section = ""
          _deeplinkObjFRX.params={}
          _deeplinkObjFRX.params.CampaignMedium = ""
          _deeplinkObjFRX.params.link =""
        }else if (selectedFRXSection.value == "BuyForMySelf") {
          _deeplinkObjFRX.params.buy_for="me"
         }
      }
    }
    }


    var myHeaders = new Headers();

    myHeaders.append("Authorization", "Bearer " + token);
    myHeaders.append("cache-control", "no-cache");
    myHeaders.append("Cookie", "__cfduid=d5b74235daa6f013fde0aba762ec288811620640208");

    var formdata = new FormData();
    formdata.append("path", "carousel/add");
    formdata.append("created_datetime", currentDate);
    if(!pocuno){
      formdata.append("userfile", selectedFiles[0], selectedFiles[0].path);
    }    else {
      let response = await fetch('https://frxassets.tgate.sg/icons/Pocuno-Default.jpg');
      let data = await response.blob()
      console.log("data",data)
      let file = new File([data], "download.jpg");
      formdata.append("userfile",file, "download.jpg")
    }
      formdata.append("title",pocuno ? "NA" : title)
      formdata.append("description", pocuno ? "NA" : description);    
    formdata.append("app_version", 1.5);
    formdata.append("item_status", status);
    formdata.append("item_type", "\"carousel_banner\"");
    formdata.append("item_version", 18);
    formdata.append("navigate_to",customCheck ? customNavigation : JSON.stringify(_deeplinkObjFRX));
    formdata.append("page", selectedSectionFRX ? selectedSectionFRX.value : section);
    formdata.append("published_at", publishAt);
    formdata.append("unpublished_at", neverEnding ? null : unpublishAt);
    formdata.append("slider_delay", "0");
    formdata.append("sort_order", position);
    formdata.append("api", true);

    var requestOptions = {
      method: 'POST',
      headers: myHeaders,
      body: formdata,
      redirect: 'follow',
      processData: false,
      mimeType: "multipart/form-data",
      async: true,
      crossDomain: true,
    };
    fetch(`${process.env.REACT_APP_TOKRI_API_URL}/api/frhub`, requestOptions)
      .then(response => {
        if (response.status == 200) {
          setsuccess_msg(true)
          setLoader(false)
        } else {
          SetErrorMessage("Unable to Add Carousel Banner")
          setErrorMsgAlert(true)
          setLoader(false)
        }
        response.json()
      })
      .catch(error => {
        console.log("here is the error---->",error)
        SetErrorMessage("Unable to Add Carousel Banner")
        setErrorMsgAlert(true)
        setLoader(false)
      });

  }
  const checkCharacterCount = (e, count) => {
    if (e.target.innerText.length > count && e.key !== 'Backspace') {
      e.preventDefault()
    }
  }

  const checkTextInsideHtml = (htmlString) => {
    const regex = /<[^>]+>([^<]+)<\/[^>]+>/;
    const matchBookingInfo = regex.exec(htmlString);
    if (matchBookingInfo && matchBookingInfo[1]) {
      return true;
    } else {
      const simpleStringRegex = /^[^<>\n]+$/;
      return simpleStringRegex.test(htmlString);
    }
  };
  const validateFileSize = (file) => {
    var reader = new FileReader();

    //Read the contents of Image File.
    reader.readAsDataURL(file[0]);
    reader.onloadend = function (e) {
      //Initiate the JavaScript Image object.
      var image = new Image();

      //Set the Base64 string return from FileReader as source.
      image.src = e.target.result;
      //Validate the File Height and Width.
      image.onload = function () {
        var height = this.height;
        var width = this.width;
        if (width !== 600 || height !== 320) {
          SetErrorMessage("Height and Width must be 600x320px")
          setErrorMsgAlert(true)
          return
       }else{
        handleAcceptedFiles(file)
       }
      };
    };
  }
  function handleAcceptedFiles(files) {
    files.map(file =>
      Object.assign(file, {
        preview: URL.createObjectURL(file),
        formattedSize: formatBytes(file.size),
      })
    )
    let path = files[0].path
    path = path.split(".")
    path = path[1]
    if (path == "jpg" || path == "JPG") {
      setselectedFiles(files)
    } else {
      SetErrorMessage("Please select a .jpg file")
      setErrorMsgAlert(true)
    }
  }
  /**
   * Formats the size
   */
  function formatBytes(bytes, decimals = 2) {
    if (bytes === 0) return "0 Bytes"
    const k = 1024
    const dm = decimals < 0 ? 0 : decimals
    const sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"]

    const i = Math.floor(Math.log(bytes) / Math.log(k))
    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + " " + sizes[i]
  }


  const handleExternalUrl = (value) =>{   
    setExternalUrl(value)
    var pattern = /^(https:\/\/|http:\/\/)([a-z]{2,})\.([a-zA-Z0-9-]{2,})+\.[a-z]{2,}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)$/;
    if(value){
      if (!pattern.test(value)) {
        setExternalUrlErrorMessage("Please enter valid URL (Including https://)");
      } else {
        setExternalUrlErrorMessage("");
      }
    }else{
      setExternalUrlErrorMessage("");
    }
  }

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid={true}>
          <Breadcrumbs title="Carousel Banners" breadcrumbItem="Add Carousel Banner" />

          <Row>
            <Col lg="12">
              <Card>
                <CardBody>
                  <div className="wizard clearfix">
                    <div className="steps clearfix">
                      <ul>
                        <NavItem
                          className={classnames({ current: activeTab === 1 })}>
                          <NavLink
                            className={classnames({ current: activeTab === 1 })}
                            onClick={() => {
                              setactiveTab(1)
                            }}
                          >
                            <span className="number">1.</span>
                            Create Carousel Banner
                          </NavLink>
                        </NavItem>
                        <NavItem className={classnames({ current: activeTab === 2 })}>
                          <NavLink
                            className={classnames({ active: activeTab === 2 })}
                            onClick={() => {
                              setactiveTab(2)
                            }}
                          >
                            <span className="number">2.</span>{" "}
                            {"Navigation"}
                          </NavLink>
                        </NavItem>
                      </ul>
                    </div>
                    <div className="content clearfix">
                      <div className="body">
                        <TabContent
                          activeTab={activeTab}
                        >
                          <TabPane tabId={1}>
                            <Form>
                              <Row>
                              </Row>
                            </Form>
                            <Row>
                              <Col className="col-12">
                                <Card>
                                  <CardBody>
                                    <Row>
                                      <Col lg={12} md={12} sm={12}>
                                        <div className="mt-5 mt-lg-4">
                                          <Form
                                            className=""
                                            method="post"
                                            id="tooltipForm">
                                            <div>
                                              <Row>
                                                <Col lg={4} md={6} sm={6}>
                                                  <div className={isUniqueExist|| EmptyPosition?"":"mb-4"}>
                                                    <Label>Position</Label>
                                                    <input
                                                    onKeyPress={(event) => {
                                                      if (!/[0-9]/.test(event.key)) {
                                                       event.preventDefault();
                                                              }
                                                                }}
                                                      onChange={(e) => {
                                                       setselectedPosition(e.target.value);
                                                       setEmptyPosition(false)}}
                                                      className="form-control"
                                                      type="number"
                                                      id="position_input"
                                                      value={selectedPosition}
                                                      min={1}
                          
                                                    />
                                                  </div>
                                                  {isUniqueExist && <div style={{ color: "red", fontSize: 12 }}>
                                                    position is unique! please choose another position
                                                  </div>}
                                                  {EmptyPosition && <div style={{ color: "red", fontSize: 12 }}>
                                                    Please Enter Position
                                                  </div>}
                                                </Col>
                                                <Col md={1}></Col>
                                              </Row>
                                              {selectedSection?.value=='home' && pocuno &&<Row><Col lg={4} md={6} sm={6}>
                                                  <div className="mb-4">
                                                    <Label>Url</Label>
                                                    <input
                                                      onChange={(e) => {setPocunoUrl(e.target.value);setEmptyUrl(false)}}
                                                      className="form-control"
                                                      type="text"
                                                      id="url_input"
                                                      value={pocunoUrl}
                                                      min={1}                         
                                                    />
                                                  </div>
                                                  {EmptyUrl && <div style={{ color: "red", fontSize: 12, marginTop:"-20px"  }}>
                                                    Please Enter Url
                                                  </div>}
                                                </Col></Row>}
                                                {selectedSection?.value=='rewards' && pocuno &&<Row><Col lg={4} md={6} sm={6}>
                                                  <div className="mb-4">
                                                    <Label>Url</Label>
                                                    <input
                                                      onChange={(e) => {setPocunoUrl(e.target.value);setEmptyUrl(false)}}
                                                      className="form-control"
                                                      type="text"
                                                      id="url_input"
                                                      value={pocunoUrl}
                                                      min={1}                         
                                                    />
                                                  </div>
                                                  {EmptyUrl && <div style={{ color: "red", fontSize: 12, marginTop:"-20px"  }}>
                                                    Please Enter Url
                                                  </div>}
                                                </Col></Row>}
                                            </div>
                                          </Form>
                                        </div>
                                      </Col>
                                    </Row>
                                    <Row>
                                      <Col lg={4} md={6} sm={6}>
                                        <div className="mb-3">
                                          <Label>Title</Label>
                                          <div className="col-md-12">
                                            <input
                                              className="form-control"
                                              type="text"
                                              defaultValue=""
                                              id="title_input"
                                              disabled={pocuno}
                                              maxLength="51"
                                            />
                                          </div>
                                        </div>
                                      </Col>
                                      </Row>
                                      <Row>
                                      <Col lg={4} md={6} sm={6}>
                                        <div className="mb-3">
                                          <Label>Description</Label>
                                          <div className="col-md-12">
                                            <input
                                              className="form-control"
                                              type="text"
                                              defaultValue=""
                                              id="description_input"
                                              disabled={pocuno}
                                              maxLength="60"
                                            />
                                          </div>
                                        </div>
                                      </Col>
                                      </Row>  

                                  </CardBody>
                                </Card>
                                <Card>
                                  <CardBody>
                                    <Form
                                     >
                                      <Dropzone
                                        onDrop={acceptedFiles => {
                                          validateFileSize(acceptedFiles)
                                        }}
                                        disabled={pocuno}
                                        
                                      >
                                        {({ getRootProps, getInputProps }) => (
                                          <div className="dropzone" style={{background:pocuno?"#F5F6F8":"" }}>
                                            <div
                                              className="dz-message needsclick"
                                              {...getRootProps()}
                                            >
                                              <input {...getInputProps()} />
                                              <div className="mb-3">
                                                <FaCloudUploadAlt className="display-4 text-muted"/>
                                              </div>
                                              <h4>Drop files here or click to upload.</h4>
                                              { !pocuno&&           
                                              <p style={{ fontSize: 12, color: "red",    marginBottom: 0 }}>{`Image should be 600X320 in jpg`}</p>}
                                              {!pocuno&& <p style={{ fontSize: 12, color: "red" }}></p>}
                                            </div>
                                          </div>
                                        )}
                                      </Dropzone>
                                      <div className="dropzone-previews mt-3" id="file-previews">
                                        {selectedFiles.map((f, i) => {
                                          return (
                                            <Card
                                              className="mt-1 mb-0 shadow-none border dz-processing dz-image-preview dz-success dz-complete"
                                              key={i + "-file"}
                                            >
                                              <div className="p-2">
                                                <Row className="align-items-center">
                                                  <Col className="col-auto">
                                                    <img
                                                      data-dz-thumbnail=""
                                                      height="80"
                                                      className="avatar-sm rounded bg-light"
                                                      alt={f.name}
                                                      src={f.preview}
                                                    />
                                                  </Col>
                                                  <Col>
                                                    <Link
                                                      to="#"
                                                      className="text-muted font-weight-bold"
                                                    >
                                                      {f.name}
                                                    </Link>
                                                    <p className="mb-0">
                                                      <strong>{f.formattedSize}</strong>
                                                    </p>
                                                  </Col>
                                                </Row>
                                              </div>
                                            </Card>
                                          )
                                        })}
                                      </div>
                                    </Form>
                                  </CardBody>
                                </Card>
                                <Card>
                                  <CardBody>
                                    <Row>
                                      <Col lg={4} md={6} sm={6}>
                                        <div className="mb-3">
                                          <Label>Publish At</Label>
                                          <div className="col-md-12">
                                            <input
                                              className="form-control"
                                              type="datetime-local"
                                              id="publishAt_input"
                                              placeholder="dd/mm/yyyy"
                                              defaultValue={""}
                                            />
                                          </div>
                                        </div>
                                      </Col>
                                      <Col lg={1}></Col>
                                      <Col lg={4} md={6} sm={6}>
                                        <div className="mb-3">
                                          <Label>Unpublish At</Label>
                                          <div className="col-md-12">
                                            <input
                                              className="form-control"
                                              type="datetime-local"
                                              id="unpublishAt_input"
                                              placeholder="dd/mm/yyyy"
                                              defaultValue={""}
                                              disabled={neverEnding}
                                              min={""}
                                            />
                                          </div>
                                        </div>
                                      </Col>
                                      <Col style={{ paddingTop: 35 }}>
                                        <div className="form-check form-switch">
                                          <input
                                            type="checkbox"
                                            className="form-check-input checkbox"
                                            id="checkbox_1"
                                            value={neverEnding}
                                            defaultChecked={neverEnding}
                                            onChange={() => { setNeverEnding(!neverEnding) }}
                                          />

                                          <label className="form-check-label" htmlFor="checkbox_1">
                                            Never-ending
                                          </label>
                                        </div>
                                      </Col>
                                    </Row>
                                  </CardBody>
                                </Card>
                                <Card>
                                  <CardBody>
                                    <Row>
                                      <Col lg={4} md={6} sm={6}>
                                        <div className="mb-3">
                                          <Label>Status</Label>
                                          <Select
                                            isSearchable={true}
                                            onChange={(e) => {
                                              setselectedStatus(e)
                                            }}
                                            options={statusOptions}
                                            placeholder={selectedStatus ? selectedStatus.label : "Choose..."}
                                            defaultValue={statusOptions[0].label}
                                            required
                                          />
                                        </div>
                                      </Col>
                                    </Row>
                                  </CardBody>
                                </Card>
                              </Col>
                            </Row>
                          </TabPane>
                          <TabPane tabId={2}>
                            <div>
                              <Form>
                                <Row>
                                  <Col lg={4} md={10} sm={10}>
                                    <div className="mb-3" >
                                      <Label>Navigate To</Label>
                                {customCheck ? 
                                <textarea
                                rows={4}
                                col={20}
                                type="text"
                                disabled={pocuno}
                                className="form-control"
                                id="item_group_input"
                                onChange={(e) => {
                                  setCustomNavigation(e.target.value);
                                }}
                                defaultValue={customNavigation}
                              />
                              :
                              <Select
                                isSearchable={true}        
                                value={selectedFRXSection}
                                onChange={(e) => {
                                  setselectedFRXSection(e)
                                  setFrxApp(true)
                                }}
                                placeholder={selectedFRXSection?.label ? selectedFRXSection?.label : "Choose section..."}
                                defaultValue={frxAppOptions[0]}
                                options={frxAppOptions}
                                maxMenuHeight={120}
                                menuPlacement="auto"
                                required
                                isDisabled={pocuno}
                                      />}
                                    </div>
                                  </Col>
                                  <Col md={1}></Col>
                                  {!pocuno && <Col md={2} style={{paddingTop:"38px"}}>
                                  <div className="form-check form-switch">
                                    <input
                                      type="checkbox"
                                      className="form-check-input checkbox"
                                      id="checkbox_custom_nav"
                                      value={customCheck}
                                      defaultChecked={customCheck}
                                      onChange={() => { 
                                      setcustomCheck(!customCheck)
                                      }}
                                    />

                                    <label className="form-check-label" htmlFor="checkbox_pocuno">
                                      Custom Navigation
                                    </label>
                                  </div>
                                  </Col>}
                                </Row>
                                <Row>
                                  {(selectedFRXSection?.label == "External Link" && !customCheck) &&
                                  <Col lg={4} md={6} sm={6}>
                                    <div className="mb-3">
                                      <Label>URL*</Label>
                                      <input
                                        className="form-control"
                                        type="text"
                                        defaultValue=""
                                        disabled={pocuno}
                                        id="external_url_input"
                                        onChange={(e) => {setFrxApp(true)                                       
                                        handleExternalUrl(e.target.value)
                                      }}
                                      />
                                      {externalUrlErrorMessage && (
                                      <p style={{ color: "red", fontSize: 12 }}>
                                        {externalUrlErrorMessage}
                                      </p>
                                    )}
                                    </div>
                                  </Col>}
                                </Row>
                                <Row>
                                  {(selectedFRXSection?.label == "External Link" && !customCheck) &&
                                    <Col lg={4} md={6} sm={6}>
                                      <div className="mb-3">
                                        <Label>{"Exit Message Description*"}</Label>
                                        <ReactQuill
                                          modules={{
                                            toolbar: [
                                              ["bold", "italic", "underline"],
                                              [{ list: "ordered" }, { list: "bullet" }],
                                              ["link", { color: [] }],
                                              ["clean"],
                                            ],
                                          }}
                                          theme="snow"
                                          value={externaLinkName}
                                          onChange={(e, delta, source, c) => {
                                            if (c.getText().length <= 2000) {
                                              setExternalLinkName(e);
                                            } else if (c.getText().length > 2000) {
                                              const remainingCharacters = 2000 - c.getText().length;
                                              let truncatedText = c.getText().slice(0, remainingCharacters);
                                              setExternalLinkName(truncatedText)
                                            }
                                          }}
                                          onKeyDown={(e) => checkCharacterCount(e, 2000)}

                                          style={{ minHeight: "30px" }}
                                        />
                                      </div>
                                    </Col>}
                                  <Col md={1}></Col>
                                </Row>
                             {/* ArticleDetail section */}
                              {(selectedFRXSection?.value == "ArticleDetail" && !customCheck) && (
                                <>
                                  <Row>
                                    <Col lg={4} md={6} sm={6}>
                                      <div className="mb-3">
                                        <Label>Mall</Label>
                                        <Select
                                          isSearchable={true}
                                          onChange={(e) => {
                                            setSelectedMall(e);
                                            setSelectedHappeningType(null);
                                          }}
                                          options={mallOptions}
                                          placeholder="Select Mall..."
                                          value={selectedMall}
                                        />
                                      </div>
                                    </Col>
                                  </Row>
                                  
                                  {selectedMall && (
                                    <Row>
                                      <Col lg={4} md={6} sm={6}>
                                        <div className="mb-3">
                                          <Label>Type</Label>
                                          <Select
                                            isSearchable={true}
                                            onChange={(e) => {
                                              setSelectedHappeningType(e);
                                            }}
                                            options={happeningTypeOptions}
                                            placeholder="Select Happening Type..."
                                            value={selectedHappeningType}
                                          />
                                        </div>
                                      </Col>
                                    </Row>
                                  )}
                                  
                                  {selectedHappeningType && (
                                    <>
                                      <Row>
                                        <Col lg={4} md={6} sm={6}>
                                        <div className="mb-3">
                                         <Label>Blog ID</Label>
                                          <input
                                            className="form-control"
                                            type="text"
                                            defaultValue=""
                                            id="article_id"
                                          />
                                        </div>
                                        </Col>
                                      </Row>
                                      <Row >
                                        <Col lg={4} md={6} sm={6}>
                                        <div className="mb-3">
                                        <Label>Header Title</Label>
                                          <input
                                            className="form-control"
                                            type="text"
                                            defaultValue=""
                                            id="title_input_frx"
                                          />
                                        </div>
                                        </Col>
                                      </Row>
                                    </>
                                  )}
                                </>
                              )}

                              {(selectedFRXSection?.label != "No Navigation" && selectedFRXSection?.label != "External Link" && !customCheck) &&
                              <Row>
                                 <Col lg={4} md={6} sm={6}>
                                    <div className="mb-3">
                                      <Label>Campaign Tracking Name</Label>
                                      <input
                                        className="form-control"
                                        type="text"
                                        defaultValue=""
                                        disabled={pocuno}
                                        id="campaign_link_input"
                                        onChange={(e) => setFrxApp(true)}
                                      />
                                    </div>
                                  </Col>
                                </Row>}
                              </Form>
                            </div>
                          </TabPane>
                        </TabContent>
                      </div>
                    </div>
                    <div className="actions clearfix">
                      <ul>
                        <li
                          className={
                            "next"
                          }
                        >
                          <Link
                            to={`/carousel-banners/${selectedSection?.path}`}
                            className="bg-danger"
                            // onClick={() => {
                            //   toggleTab(activeTab - 1)
                            // }}
                            style={{ paddingTop: 8, paddingBottom: 10 }}
                          >
                            <i className="uil uil-times me-1"></i>Cancel
                          </Link>
                        </li>
                        <li
                          className={
                            activeTab === 1 ? "previous hidden" : "previous"
                          }
                        >
                          <Link
                            to="#"
                            className="btn btn-primary"
                            onClick={() => {
                              toggleTab(activeTab - 1)
                            }}
                          >
                            Previous
                          </Link>
                        </li>
                        <li
                          className={activeTab === 4 ? "next disabled" : "next"}
                        >
                          <button                    
                            disabled={loader}
                            style={{color:"#ffffff", width:"80px"}}
                            className={activeTab > 1 ? "btn bg-success" : "btn btn-primary"}
                            onClick={() => {
                              if (activeTab === 2) {
                                handleSubmit()
                        
                                return
                              } else {
                                toggleTab(activeTab + 1)
                              }
                            }}
                          >
                            {activeTab === 2 ? loader ? (
                            <CircularProgress
                              size={15}
                              value={100}
                              color={"white"}
                            />
                          ) : (
                            "Save"
                          ) : "Next"}
                          </button>
                        </li>
                      </ul>
                    </div>

                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
          {success_msg ? (
            renderSuccessAlert()
          )
            :
            null
          }
          {errorMsgAlert ? (
            renderFailureAlert()
          )
            :
            null
          }
        </Container>
      </div>
    </React.Fragment>
  )
}
export default AddCarouselBannerNew
